(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.revealHeaderOnPageRestore = () => {
        const syncRestoredScrollPosition = () => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > 0) {
            this.currentScrollTop = scrollTop;
            this.reveal();
          }
        };

        window.requestAnimationFrame(syncRestoredScrollPosition);
        window.setTimeout(syncRestoredScrollPosition, 100);
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('load', this.revealHeaderOnPageRestore);
      window.addEventListener('pageshow', this.revealHeaderOnPageRestore);

      this.createObserver();
      this.revealHeaderOnPageRestore();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.revealHeaderOnPageRestore);
      window.removeEventListener('pageshow', this.revealHeaderOnPageRestore);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  var linkItems = document.querySelectorAll('.mrHeader-linkItem');

  // Iterate over the selected elements
  linkItems.forEach(function(linkItem) {
    // Check if the element contains the text 'new in'
    if (linkItem.textContent.includes('new in')) {
      // Add the 'new' class to the element
      linkItem.classList.add('new');
    }
  });

    // Get all elements with the class 'mrHeader-linkItem'
  var linkItems = document.querySelectorAll('.mrHeader-linkItem');

  // Iterate over the selected elements
  linkItems.forEach(function(linkItem) {
    // Check if the element contains the text 'specials'
    if (linkItem.textContent.includes('specials')) {
      // Add the 'special' class to the element
      linkItem.classList.add('special');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
